<div
  class="spinner spinner--horizontal"
  [ngClass]="['spinner--' + size, 'spinner--' + render, 'spinner--' + direction]">
  <div class="spinner__circle"></div>

  <div class="spinner__label" *ngIf="label.length">
    {{ label }}
  </div>
</div>
